import {WatchlistModel, XJO} from "./WatchlistModel";
import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";
import {Exchange} from "../../instruments/exchange/Exchange";
import {QuoteViewModel} from "../../quote/models/QuoteViewModel";
import {WatchlistId} from "./WatchlistId";
import {WatchlistType} from "./WatchlistType";
import {Comparator} from "../../types/GenericTypes";
import {SecurityUtil} from "../../js/util/SecurityUtil";
import {PriceStrategy} from "../../components/inputs/price/input/PriceStrategy";
import {NewsHeadlineIndicatorModel} from "../../news/models/NewsHeadlineIndicatorModel";
import {WatchlistSorting} from "./WatchlistSort";

export class WatchlistViewModel {

    private constructor(private readonly model: WatchlistModel,
                        public readonly items: WatchlistItemViewModels,
                        public readonly sorting: WatchlistSorting) {
    }

    public get id(): WatchlistId {
        return this.model.id;
    }

    public get name(): string {
        return this.model.name;
    }

    public get isSystemDefined(): boolean {
        return this.model.type === WatchlistType.SYSTEM;
    }

    public static create(model: WatchlistModel,
                         items: WatchlistItemViewModels,
                         sorting: WatchlistSorting): WatchlistViewModel {
        return new WatchlistViewModel(model, items, sorting);
    }
}

export type WatchlistItemViewModels = ReadonlyArray<WatchlistItemViewModel>;

export class WatchlistItemViewModel implements CodeAndExchange {

    public readonly isPoints: boolean;
    public readonly absChange: number;

    private constructor(private readonly security: CodeAndExchange,
                        public readonly priceStrategy: PriceStrategy,
                        public readonly sref: string | null,
                        public readonly quote: QuoteViewModel,
                        public readonly headline: NewsHeadlineIndicatorModel | null) {
        this.isPoints = SecurityUtil.isIndex(this.code);
        this.absChange = Math.abs(this.change);
    }

    public get code(): string {
        return this.security.code;
    }

    public get exchange(): Exchange {
        return this.security.exchange;
    }

    public get price(): number {
        return this.quote.last!;
    }

    public get change(): number {
        return this.quote.quote.change;
    }

    public get changePct(): number {
        return this.quote.quote.changePct;
    }

    public static create(security: CodeAndExchange,
                         strategy: PriceStrategy,
                         sref: string | null,
                         quote: QuoteViewModel,
                         headline: NewsHeadlineIndicatorModel | null): WatchlistItemViewModel {
        return new WatchlistItemViewModel(security, strategy, sref, quote, headline);
    }
}

export function orderWatchListItems(): Comparator<WatchlistItemViewModel> {
    return (a, b) => {
        // XJO goes first
        if (a.code === XJO.code) {
            if (a.code === b.code) {
                return 0;
            } else {
                return -1;
            }
        } else if (b.code === XJO.code) {
            return 1;
        } else {
            return a.code.localeCompare(b.code);
        }
    };
}

export function orderWatchListItemsByCode(): Comparator<WatchlistItemViewModel> {
    return (a, b) => {
        return a.code.localeCompare(b.code);
    };
}

export function orderWatchListItemsByChangePct(): Comparator<WatchlistItemViewModel> {
    return (a, b) => {
        return a.changePct - b.changePct;
    };
}
